// Redux Action Types
import { SET_CONTEXT } from '../actions/types';
// Initial State
const initialState = false;

export default function (state = initialState, action) {
  if (action.type === SET_CONTEXT) return action.payload;
  return state;
}
